var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"top":"","color":_vm.type,"value":_vm.snackbar,"timeout":_vm.timeout,"multi-line":""},on:{"input":_vm.hide},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attr = ref.attr;
return [_c('v-btn',_vm._b({attrs:{"elevation":"2","icon":""},on:{"click":_vm.hide}},'v-btn',attr,false),[_c('v-icon',[_vm._v(" mdi-window-close ")])],1)]}}])},[_vm._v(" "+_vm._s(_vm.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }